document.addEventListener("DOMContentLoaded", function () {
  if (typeof jQuery !== 'undefined') {
    $('.feature-slider').slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 3000,
      arrows: true,
      dots: false,
      responsive: [
        { breakpoint: 1024, settings: { slidesToShow: 2 }},
        { breakpoint: 768, settings: { slidesToShow: 1 }}
      ]
    });
  } else {
    console.warn("jQuery not loaded, slider won't initialize.");
  }
});
